var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyzeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.41176C0 4.21379 4.21379 0 9.41177 0H30.5882C35.7862 0 40 4.21379 40 9.41177V30.5882C40 35.7862 35.7862 40 30.5882 40H9.41176C4.21379 40 0 35.7862 0 30.5882V9.41176Z",
    fill: "#7951EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C15.5817 10 12 13.5817 12 18V27.9C12 28.2314 11.7314 28.5 11.4 28.5H10.6C10.2686 28.5 10 28.2314 10 27.9V18C10 12.4772 14.4772 8 20 8C25.5228 8 30 12.4772 30 18V30.4C30 31.2837 29.2837 32 28.4 32H26.1C25.2163 32 24.5 31.2837 24.5 30.4V24.5H18.6C17.7163 24.5 17 23.7837 17 22.9V20.6C17 19.7163 17.7163 19 18.6 19H24.5V18C24.5 15.5147 22.4853 13.5 20 13.5C17.5147 13.5 15.5 15.5147 15.5 18V30.4C15.5 31.2837 14.7837 32 13.9 32H10.6C10.2686 32 10 31.7314 10 31.4V30.6C10 30.2686 10.2686 30 10.6 30H13.5V18C13.5 14.4101 16.4101 11.5 20 11.5C23.5899 11.5 26.5 14.4101 26.5 18V19.7761C26.5 20.4521 25.952 21 25.2761 21H19V22.5H25.1C25.8732 22.5 26.5 23.1268 26.5 23.9V30H28V18C28 13.5817 24.4183 10 20 10Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeLogo);
export default __webpack_public_path__ + "static/media/Analyze-logo.eacc13b14e009d23da80f1fefefa30a8.svg";
export { ForwardRef as ReactComponent };